export const coreAddresses = {
  balanceTracker: "0xFbD12fbC91311A8f17598b935e35205EAF16Aa75",
  eVaultFactory: "0xbAd8b5BDFB2bcbcd78Cc9f1573D3Aad6E865e752",
  eVaultImplementation: "0x71d7250732591C41D1BdeB1EA0Ee730E138E0c8b",
  eulerEarnFactory: "0xD785adD5F081F56616898E45b90dE307e3DC7d3E",
  evc: "0x2A1176964F5D7caE5406B627Bf6166664FE83c60",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0xdCD02E4eA8cd273498D315AD8c047305f8480656",
  sequenceRegistry: "0x08799a00BC4a74890d65f77828cd2BFbBFcD96dB",
} as const
